@if (hasPendingConflicts()) {
  <p-tag
    [rounded]="true"
    severity="warn"
    [value]="'entities.campaign.tags.conflicts' | transloco"
    styleClass="whitespace-nowrap text-xs cursor-pointer"
    (click)="$event.stopPropagation(); resolveConflicts.emit()" />
}
@if (hasImportedData() && !hasPendingConflicts()) {
  <p-tag
    [rounded]="true"
    severity="success"
    [value]="'entities.campaign.tags.imported' | transloco"
    styleClass="whitespace-nowrap text-xs" />
}
